import React from "react";
import { RaceDTO } from "../../interfaces/RaceDTO";
import moment from "moment";

interface Props {
  race: RaceDTO;
  onClick: (raceid: number) => void;
}

type spImages = {
  [key: string]: string; // Maps sport names to image filenames
};

const Race = ({ race, onClick }: Props) => {
  const isToday = (): boolean => {

    return moment(race.RaceDate).format("yyyy-MM-DD") === moment().format("yyyy-MM-DD");
  };

  const sportImages: spImages = {
    bt: "biathlon.png",
    cc: "crosscountry.png",
    al: "alpine.png",
    ol: "orientering.png",
    ru: "running.png",
    // Add more mappings as necessary
  };

  // Construct the full URL for the background image
  const backgroundImageUrl = sportImages[race.Sport.toLowerCase()]
    ? `http://${process.env.PUBLIC_URL}/static/media/${sportImages[race.Sport.toLowerCase()]}`
    : "";

  return (
    <a
      href={`/live?raceid=${race.Id}`}
      className="race-choose-row"
      data-raceid={race.Id}
      data-racedate={moment(race.RaceDate).format("yyyy-MM-DD")}
    >
      <div
        className={`race-choose-sport race-choose-${race.Sport.toLowerCase()}`}
        data-sport={race.Sport}
        style={{
          backgroundColor: isToday() ? "green" : "",
        }}
      >
        {isToday() ? (
          <span
            style={{
              color: "white",
              verticalAlign: "revert-layer",
              transform: "translateY(25px)",
              display: "block",
              marginLeft: "3px",
              fontWeight: "600",
            }}
          >
            LIVE
          </span>
        ) : (
          <>&nbsp;</>
        )}
      </div>
      <div className="race-choose-info">
        <div className="race-choose-main-info">
          <span data-id="race-choose-name">{race.Name}</span>
        </div>
        <div className="race-choose-second-info">
          <span data-id="race-choose-date">
            {race.RaceDate === null ? null : moment(race.RaceDate).format("yyyy-MM-DD")}
          </span>
          <span data-id="race-choose-place">{race.Place}</span>
        </div>
      </div>
    </a>
  );
};

export default Race;
